import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check, Minus } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // Base styles
      "peer h-4 w-4 shrink-0 rounded-[4px] border transition-all duration-[120ms]",
      // Focus styles
      "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      // Disabled styles
      "disabled:cursor-not-allowed disabled:opacity-50",
      // Unchecked state - branco com borda cinza
      "bg-white border-[#C9CCD6]",
      // Hover state (unchecked) - borda mais escura
      "hover:border-[#AEB3C2]",
      // Checked state - azul HostVSL #2563EB
      "data-[state=checked]:bg-[#2563EB] data-[state=checked]:border-[#2563EB]",
      "data-[state=checked]:hover:bg-[#1D4ED8] data-[state=checked]:hover:border-[#1D4ED8]",
      // Indeterminate state - azul HostVSL #2563EB
      "data-[state=indeterminate]:bg-[#2563EB] data-[state=indeterminate]:border-[#2563EB]",
      "data-[state=indeterminate]:hover:bg-[#1D4ED8] data-[state=indeterminate]:hover:border-[#1D4ED8]",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn(
        "flex items-center justify-center text-white animate-checkbox-scale"
      )}
    >
      {props.checked === "indeterminate" ? (
        // Barra horizontal branca para estado indeterminate
        <div className="w-[60%] h-[2px] bg-white rounded-[2px]" />
      ) : (
        // Ícone check branco com tamanho +10%
        <Check className="h-[1.1rem] w-[1.1rem]" strokeWidth={2.5} />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
